import React from 'react'
import { Space } from 'antd'
import { useFetchTextSubmissionDetailsQuery } from '../../../../../store/apis/submission.api'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import StatisticsWithProgress from '../../../../../components/common/StatisticsWithProgress'
import useRubricContext from '../../../../../hooks/useRubricContext'

const TextSubmissionStatisics = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)

    const { questions, getCategoryById } = useRubricContext()
    
    const { data: submission } = useFetchTextSubmissionDetailsQuery({
        submissionId: openedSubmissionId,
    })

    const reviewedAnswers = submission?.answers.filter(answer => answer.approveStatus)

    const reviewedAnswersCount = reviewedAnswers?.length

    const grade = Math.max(
        reviewedAnswers?.reduce((acc, answer) => {
            const category = getCategoryById(answer.categoryId)
            const categoryGrade = category?.grade || 0
            return acc + categoryGrade
        }, 0),
        0,
    )
    const gradeRounded = Math.round(grade * 100) / 100

    // Count total questionRubrics across all questions
    const totalQuestionRubrics = questions?.reduce((acc, question) => {
        return acc + (question.questionRubrics?.length || 0)
    }, 0) ?? 0

    // Sum weights from all questionRubrics' rubrics
    const maxGrade = questions?.reduce((acc, question) => {
        const questionWeight = question.questionRubrics?.reduce(
            (qrAcc, qr) => qrAcc + (qr.rubric?.weight || 0), 
            0
        ) || 0
        return acc + questionWeight
    }, 0) ?? '...'
    const maxGradeRounded = maxGrade !== '...' ? Math.round(maxGrade * 100) / 100 : maxGrade

    return (
        <Space size='large' className='mr-16'>
            <StatisticsWithProgress
                label='Approved Grading Items'
                current={reviewedAnswersCount}
                total={totalQuestionRubrics}
                steps={totalQuestionRubrics}
                style={{ fontSize: 14 }}
                title='Progress on classifications for full review of this submission'
                size='small'
            />
            <StatisticsWithProgress
                label='Approved Points'
                current={gradeRounded}
                total={maxGradeRounded}
                steps={maxGradeRounded}
                style={{ fontSize: 14 }}
                size='small'
            />
        </Space>
    )
}

export default TextSubmissionStatisics
